import React from 'react';
import { Keyboard, TouchableWithoutFeedback, KeyboardAvoidingView, ViewProps, Platform } from 'react-native';

interface PressCloseKeyboardProps extends ViewProps {
    children: React.ReactNode;
}

const PressCloseKeyboard: React.FC<PressCloseKeyboardProps> = ({ children, style, ...props }) => {
    // Web: TouchableWithoutFeedback usa responder system do RNWeb, que rouba foco
    // de TextInput no mousedown (input seleciona e desfoca sem deixar digitar).
    // Keyboard.dismiss() nao faz nada util na web, entao so pulamos o wrapper.
    if (Platform.OS === 'web') {
        return <>{children}</>;
    }

    return (
        <TouchableWithoutFeedback onPress={() => Keyboard.dismiss()} accessible={false}>

                {children}
        </TouchableWithoutFeedback>
    );
};

export default PressCloseKeyboard;